import HistoryPointComponent from '@components/history-point';
import * as React from 'react';

export interface IHistoryPointProps {}

export default function HistoryPoint(props: IHistoryPointProps) {
  return <HistoryPointComponent />;
}
